import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Autocomplete, Button, Checkbox, CircularProgress, Container, createFilterOptions, FormControl, FormControlLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import Box from '@mui/system/Box';
import { getAuth } from 'firebase/auth';
import { collection, doc, getDoc, getDocsFromServer, limit, orderBy, query, QueryConstraint, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { FC, Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EmployerInfo } from '../../consts/types/employer';
import { UserType } from '../../consts/types/general';
import { Areas, UserDegree, UserInfo } from '../../consts/types/user';
import { db } from '../../firebase';
import { authActionsCreators } from '../../reducers/auth';
import { employerActionsCreators, EmployerSelectors } from '../../reducers/employer';
import { UserSelectors } from '../../reducers/user';
import AppBarComp from '../AppBarComp';
import Login from '../Login';
import CandidateCard from './CandidateCard';
const { NotificationManager } = require('react-notifications');

const filter = createFilterOptions<{ inputValue?: string, title: string }>();

const StyledRating = styled(Rating)({
    gap: 2,
    '& .MuiRating-iconFilled': {
        color: '#1976d2',
    },
    '& .MuiRating-iconHover': {
        color: '#3390ed',
    },
});
interface EmployerProps {

}

type Props = EmployerProps;


const Employer: FC<Props> = (props: Props) => {
    const employer = useSelector(EmployerSelectors.currentEmployer);
    const user = useSelector(UserSelectors.currentUser);
    const [skillsExpanded, setSkillsExpanded] = useState(true);
    const [educationExpanded, setEducationExpanded] = useState(false);
    const [generalExpanded, setGeneralExpanded] = useState(false);
    const [areas, setAreas] = useState<string[]>([]);
    const [degrees, setDegrees] = useState<UserDegree[]>([]);
    const [experience, setExperience] = useState(0);
    const [experienceMoreOrLess, setExperienceMoreOrLess] = useState<"Or more" | "Or less">("Or more");

    const [skills, setSkills] = useState<string[]>([]);
    const [skillsListOpen, setSkillsListOpen] = useState(false);
    const [skillsOptions, setSkillsOptions] = useState<{ inputValue?: string, title: string }[]>([]);
    const skillsLoading = skillsListOpen && skillsOptions.length === 0;

    const [startup, setStartup] = useState(false);
    const [management, setManagement] = useState(false);

    // const [personality, setPersonality] = useState<Record<PersonalityQuestion, number>>({} as Record<PersonalityQuestion, number>);
    // const [approved, setApproved] = useState(true);

    const [candidates, setCandidates] = useState<UserInfo[] | null>(null);
    const [candidatesLoading, setCandidatesLoading] = useState(false);

    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            getAuth().signOut().catch(() => { });
        }
    }, []); //eslint-disable-line

    useEffect(() => {
        if (candidatesLoading || !employer) {
            return undefined;
        }
        if (employer && !employer.profileUpdated) {
            navigate("/employer/profile")
        }
        const usersCollection = collection(db, "users",);
        // const queryByParams = query(usersCollection,);
        const q = query(usersCollection, limit(10),
            // where("approved", "==", true),
            orderBy("experienceYears", "desc"),
            orderBy("metadata.creationTime", "desc"));
        setCandidatesLoading(true);
        getDocsFromServer(q)
            .then(querySnapshot => {
                setCandidatesLoading(false);
                const docsData: UserInfo[] = [];
                querySnapshot.forEach(doc => {
                    docsData.push(doc.data() as UserInfo);
                })
                setCandidates(docsData);
            })
            .catch((e) => {
                NotificationManager.error("An error occurred.")
                setCandidatesLoading(false);
            });

    }, [employer]); //eslint-disable-line

    useEffect(() => {
        if (!skillsLoading) {
            return undefined;
        }
        getDoc(doc(db, "staticData", "skills"))
            .then(docSnap => {
                if (docSnap.exists()) {
                    setSkillsOptions(Object.keys(docSnap.data()).map(skill => ({
                        inputValue: skill,
                        title: skill
                    })))
                }
            })

    }, [skillsLoading]);

    useEffect(() => {
        if (!skillsListOpen) {
            setSkillsOptions([]);
        }
    }, [skillsListOpen]);

    // const handleApprovedInfoClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };
    const reset = () => {
        setSkills([]);
        setDegrees([]);
        setExperience(0);
        setExperienceMoreOrLess("Or more");
        setManagement(false);
        setStartup(false);
        setAreas([]);
    }

    const onLoginSuccess = (authResult: any) => {
        // if (authResult.additionalUserInfo.isNewUser) {
        const docRef = doc(db, "employers", authResult.user.email);
        getDoc(docRef).then(docSnap => {
            if (!docSnap.exists()) {
                setDoc(doc(db, "employers", authResult.user.email), {
                    name: authResult.user.displayName,
                    phone: authResult.user.phoneNumber,
                    email: authResult.user.email,
                    metadata: { creationTime: serverTimestamp() }
                })
                    .then(async () => {
                        const docRef = doc(db, "employers", authResult.user.email);
                        const docSnap = await getDoc(docRef);
                        if (docSnap.exists()) {
                            dispatch(authActionsCreators.setUserType({
                                type: UserType.Employer
                            }));
                            dispatch(employerActionsCreators.setEmployer({
                                employer: { ...docSnap.data() as EmployerInfo, }
                            }));
                        }
                        else {
                            dispatch(employerActionsCreators.setEmployer({ employer: null }));
                        }
                    })
                    .catch(() => {
                        alert("error")
                    });
            }
        });

        // }

        return false;
    }

    const findCandidates = () => {
        const usersCollection = collection(db, "users",);
        const queryConstraints: QueryConstraint[] = [];
        let skillsFiltered = false;
        let degreesFiltered = false;
        let areasFiltered = false;
        if (skills.length > 0) {
            skillsFiltered = true;
            queryConstraints.push(where('skillsNames', 'array-contains-any', skills));
        }
        else if (degrees.length > 0) {
            degreesFiltered = true;
            queryConstraints.push(where('degrees', 'array-contains-any', degrees));
        }
        else if (areas.length > 0) {
            areasFiltered = true;
            queryConstraints.push(where('area', 'in', areas));
        }
        if (experience > 0) {
            queryConstraints.push(where('experienceYears', experienceMoreOrLess === "Or more" ? ">=" : "<=", experience));
            queryConstraints.push(orderBy("experienceYears", "desc"));
        }
        // if (approved) {
        //     queryConstraints.push(where('approved', '==', true));
        // }
        if (startup) {
            queryConstraints.push(where('startup', '==', true));
        }
        if (management) {
            queryConstraints.push(where('management', '==', true));
        }
        const q = query(usersCollection,
            limit(100),
            ...queryConstraints,
            orderBy("metadata.creationTime", "desc")
        );
        setCandidatesLoading(true);
        getDocsFromServer(q)
            .then(querySnapshot => {
                setCandidatesLoading(false);
                let docsData: UserInfo[] = [];
                querySnapshot.forEach(doc => {
                    docsData.push(doc.data() as UserInfo);
                });
                if (skills.length > 0 && !skillsFiltered) {
                    docsData = docsData.filter(doc => skills.some(skill => !!doc.skills.find(s => s.skill === skill)));
                }
                if (degrees.length > 0 && !degreesFiltered) {
                    docsData = docsData.filter(doc => degrees.some(degree => doc.degrees?.includes(degree)));
                }
                if (areas.length > 0 && !areasFiltered) {
                    docsData = docsData.filter(doc => areas.some(area => doc.area === area));
                }
                // const personalityTypesToCheck = Object.entries(personality).filter(([type, value]) => !!value);
                // if (personalityTypesToCheck.length > 0) {
                //     docsData = docsData.filter(doc => {
                //         return personalityTypesToCheck.some(([type, value]) => {
                //             if (!doc.personality) {
                //                 return false;
                //             }
                //             return value - doc.personality[type as PersonalityQuestion] <= 1;
                //         });
                //     });
                // }
                setCandidates(docsData);
            })
            .catch((e) => {
                NotificationManager.error("An error occurred.")
                setCandidatesLoading(false);
            })
    }

    return <Box height={{ xs: "initial", md: "100vh", background: "#f5f5f5" }} minHeight="100vh" display="flex" flexDirection="column" >
        <AppBarComp />
        <Container maxWidth="lg" sx={{ display: "flex", flexDirection: "column", flex: 1, pt: 3, pb: { xs: "60px", md: "40px" } }}>
            <Box display="flex" height="100%" gap={3} flexDirection="column">
                {employer === null && <Box display="flex" justifyContent="center" alignItems="baseline" flex={1} >
                    <Box padding={3} minHeight="30vh" minWidth="20vw" sx={{ background: "white", borderRadius: "8px", boxShadow: "0px 1px 5px rgb(32 38 74 / 15%)" }} mt={5}>
                        <Typography fontSize={{ xs: "1.5rem", md: "2rem" }} textAlign="center" fontWeight={500} mb={5}>Sign in</Typography>
                        <Login onSuccess={onLoginSuccess} />
                    </Box>

                </Box>
                }
                {employer && employer.profileUpdated && <Box display="flex" flex={1} flexDirection={{ xs: "column", md: "row" }} gap={2}>
                    <Box display="flex" flexDirection="column" flex={{ xs: 1, md: 0.3 }} px={2} pb={2} pt={2.5} sx={{ borderRadius: "8px", background: "#fbfbfb", overflowY: "auto", overflowX: "hidden" }} position="relative" maxHeight={{ xs: "initial", md: "calc(100vh - 165px)" }}>
                        {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography fontWeight={500}>Job Parameters</Typography>
                            <Button size="small" color="inherit" onClick={() => { reset() }}>Reset</Button>
                        </Box> */}

                        {/* <Box display="flex" alignItems="center">
                            <FormControlLabel sx={{ mb: 1 }} control={<Switch checked={approved} onChange={(e, checked) => { setApproved(checked) }} />} label="Approved candidates only" />
                            <IconButton onClick={handleApprovedInfoClick} size="small" sx={{ color: "#c6c6c6", mt: -1, ml: -1 }}>
                                <Info color="inherit" />
                            </IconButton>
                        </Box>

                        <Popover
                            open={Boolean(anchorEl)}
                            anchorEl={anchorEl}
                            onClose={() => setAnchorEl(null)}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                        >
                            <Typography sx={{ px: 2, pt: 2 }}>Turn off to see all matching candidates.</Typography>
                            <Typography sx={{ px: 2, pb: 2 }}>Including the ones we didn't approve yet.</Typography>
                        </Popover> */}
                        <Accordion expanded={skillsExpanded} onChange={(event, isExpanded) => { setSkillsExpanded(isExpanded); }} >
                            <AccordionSummary
                                expandIcon={<Box display="flex" gap={1}>
                                    {!skillsExpanded && skills.length > 0 && <Typography color="primary" fontSize="0.85rem">{skills.length + (skills.length === 1 ? " skill" : " skills")}</Typography>}
                                    <ExpandMoreIcon />
                                </Box>}
                            >
                                <Typography fontSize="0.9rem" sx={{ width: '80%', flexShrink: 0 }}>
                                    Skills (10 max)
                                </Typography>

                            </AccordionSummary>
                            <AccordionDetails>
                                <Autocomplete value={skills.map(s => ({ inputValue: s, title: s }))}
                                    multiple
                                    disableCloseOnSelect
                                    loading={skillsLoading}
                                    open={skillsListOpen}
                                    sx={{ mb: 2 }}
                                    onOpen={() => {
                                        setSkillsListOpen(true);
                                    }}
                                    onClose={() => {
                                        setSkillsListOpen(false);
                                    }}
                                    onChange={(event, newValue, reason, details) => {
                                        const option = details?.option;
                                        if (newValue && option && option.inputValue) {
                                            // Create a new value from the user input
                                            if (!skillsOptions.find(opt => opt.inputValue === option.inputValue)) {
                                                setDoc(doc(db, "staticData", "skills"), {
                                                    [option.inputValue]: option.inputValue
                                                }, { merge: true })
                                            }
                                            // setNewSkill({
                                            //     title: newValue.inputValue,
                                            // });
                                            if (skills.length < 10) {
                                                setSkills(newValue.map(val => val.inputValue || ""));
                                            }
                                        }
                                        else {
                                            if (skills.length < 10) {
                                                setSkills(newValue.map(val => val.inputValue || ""));
                                            }
                                        }
                                    }}
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options.filter(option => !skills.find(skill => skill === option.inputValue)), params);

                                        const { inputValue } = params;
                                        // Suggest the creation of a new value
                                        const isExisting = options.some((option) => inputValue === option.title);
                                        if (inputValue !== '' && !isExisting) {
                                            filtered.push({
                                                inputValue,
                                                title: `Add "${inputValue}"`,
                                            });
                                        }

                                        return filtered;
                                    }}
                                    getOptionLabel={(option) => {
                                        // Value selected with enter, right from the input
                                        if (typeof option === 'string') {
                                            return option;
                                        }
                                        // Add "xxx" option created dynamically
                                        if (option.inputValue) {
                                            return option.inputValue;
                                        }
                                        // Regular option
                                        return option.title;
                                    }}
                                    options={skillsOptions}
                                    renderOption={(props, option) => <li {...props}>{option.title}</li>}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Add Skill"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <Fragment>
                                                        {skillsLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </Fragment>
                                                ),
                                            }}

                                        />
                                    )}
                                    ChipProps={{ sx: { fontWeight: 500 }, size: "small" }}
                                />
                            </AccordionDetails>
                        </Accordion>
                        {/* Education */}
                        <Accordion expanded={educationExpanded} onChange={(event, isExpanded) => { setEducationExpanded(isExpanded); }} >
                            <AccordionSummary
                                expandIcon={<Box display="flex" gap={1}>
                                    {!educationExpanded && degrees.length > 0 && <Typography color="primary" fontSize="0.85rem">{degrees.length + (degrees.length === 1 ? " degree" : " degrees")}</Typography>}
                                    <ExpandMoreIcon />
                                </Box>}
                            >
                                <Typography fontSize="0.9rem" sx={{ width: '90%', flexShrink: 0 }}>
                                    Education & Experience
                                </Typography>

                            </AccordionSummary>
                            <AccordionDetails>
                                <FormControl fullWidth sx={{ mb: 2 }} >
                                    {/* <InputLabel >Degree</InputLabel> */}
                                    <Autocomplete value={degrees.map(d => ({ inputValue: d, title: d }))}
                                        multiple
                                        options={Object.values(UserDegree).filter(dOption => !degrees.find(df => df === dOption)).map(d => ({ inputValue: d, title: d }))}
                                        getOptionLabel={(option) => {
                                            // Value selected with enter, right from the input
                                            if (typeof option === 'string') {
                                                return option;
                                            }
                                            // Add "xxx" option created dynamically
                                            if (option.inputValue) {
                                                return option.inputValue;
                                            }
                                            // Regular option
                                            return option.title;
                                        }}
                                        onChange={(event, newValue, reason, details) => {
                                            const option = details?.option;
                                            if (newValue && option && option.inputValue) {
                                                setDegrees(newValue.map(val => val.inputValue || ""));
                                            }
                                            else {
                                                setDegrees(newValue.map(val => val.inputValue || ""));
                                            }
                                        }}
                                        renderOption={(props, option) => <li {...props}>{option.title}</li>}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Degree"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <Fragment>
                                                            {params.InputProps.endAdornment}
                                                        </Fragment>
                                                    ),
                                                }}

                                            />
                                        )} />
                                </FormControl>
                                <Box display="flex" gap={2} mb={2}>
                                    <TextField type="number" label="Experience Years"

                                        value={experience}
                                        onChange={(event) => setExperience(Number(event.target.value))}
                                        sx={{ flex: 1, }} />
                                    <Select
                                        value={experienceMoreOrLess}
                                        onChange={(e) => { setExperienceMoreOrLess(e.target.value as any) }}
                                    >
                                        <MenuItem value={"Or more"} >Or more</MenuItem>
                                        <MenuItem value={"Or less"} >Or less</MenuItem>

                                    </Select>
                                </Box>
                                <FormControlLabel control={<Checkbox checked={management} onChange={(e, checked) => { setManagement(checked) }} />}
                                    label={<Box display="flex" flexDirection="column">
                                        <Typography>Management Experience</Typography>
                                    </Box>} />
                                <FormControlLabel control={<Checkbox checked={startup} onChange={(e, checked) => { setStartup(checked) }} />}
                                    label={<Box display="flex" flexDirection="column">
                                        <Typography>Startup Experience</Typography>
                                    </Box>} />
                            </AccordionDetails>
                        </Accordion>
                        {/* General */}
                        <Accordion expanded={generalExpanded} onChange={(event, isExpanded) => { setGeneralExpanded(isExpanded); }} >
                            <AccordionSummary
                                expandIcon={<Box display="flex" gap={1}>
                                    {!generalExpanded && areas.length > 0 && <Typography color="primary" fontSize="0.85rem">{areas.length + (areas.length === 1 ? " area" : " areas")}</Typography>}
                                    <ExpandMoreIcon />
                                </Box>}
                            >
                                <Typography fontSize="0.9rem" sx={{ width: '80%', flexShrink: 0 }}>
                                    General
                                </Typography>
                                {/* <Typography sx={{ color: 'text.secondary' }}>I am an accordion</Typography> */}
                            </AccordionSummary>
                            <AccordionDetails>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                    <Autocomplete value={areas.map(a => ({ inputValue: a, title: a }))}
                                        multiple
                                        options={Object.values(Areas).filter(fa => !areas.find(a => a === fa)).map(a => ({ inputValue: a, title: a }))}
                                        getOptionLabel={(option) => {
                                            // Value selected with enter, right from the input
                                            if (typeof option === 'string') {
                                                return option;
                                            }
                                            // Add "xxx" option created dynamically
                                            if (option.inputValue) {
                                                return option.inputValue;
                                            }
                                            // Regular option
                                            return option.title;
                                        }}
                                        onChange={(event, newValue, reason, details) => {
                                            const option = details?.option;
                                            if (newValue && option && option.inputValue) {
                                                setAreas(newValue.map(val => val.inputValue || ""));
                                            }
                                            else {
                                                setAreas(newValue.map(val => val.inputValue || ""));
                                            }
                                        }}
                                        renderOption={(props, option) => <li {...props}>{option.title}</li>}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Area"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <Fragment>
                                                            {params.InputProps.endAdornment}
                                                        </Fragment>
                                                    ),
                                                }}

                                            />
                                        )} />

                                </FormControl>
                                {/* <Typography mt={2} mb={1} color="text.secondary">Personality Characteristics</Typography>
                                <Typography color="text.secondary" fontSize="0.8rem">Please define the importance of each characteristic for the job</Typography>
                                {Object.values(PersonalityQuestion).map(type => <Box mt={2} key={type}>
                                    <Typography mb={2} fontSize="0.95rem">{PersonalityQuestionTitles[type]}</Typography> */}

                                {/* <StyledRating size="large" */}
                                {/* value={personality[type] || 0} */}
                                {/* precision={1} */}
                                {/* onChange={(event, newValue) => { */}
                                {/* setPersonality({ ...personality, [type]: newValue }); */}
                                {/* }} */}
                                {/* // onChangeActive={(event, newHover) => { */}
                                {/* //     setHover({ ...hover, [type.type]: newHover }); */}
                                {/* // }} */}
                                {/* icon={<Circle fontSize="inherit" />} */}
                                {/* emptyIcon={<Circle style={{ opacity: 0.55 }} fontSize="inherit" />} */}
                                {/* /> */}
                                {/* {personality[type.type] !== null && (
                                            <Box sx={{ ml: 2, whiteSpace: "nowrap" }}>{labels[hover[type.type] !== -1 ? hover[type.type] : personality[type.type]]}</Box>
                                        )} */}

                                {/* </Box>)} */}
                            </AccordionDetails>
                        </Accordion>
                        <Box position="sticky" bottom="0" textAlign='center' width="100%" mt={2}>
                            <Button variant="contained" fullWidth color="primary" onClick={() => { findCandidates() }}>Find</Button>
                        </Box>
                    </Box>
                    {/* Results */}

                    <Box display="flex" flexDirection="column" sx={{ overflowY: "auto", borderRadius: "8px", }} px={{ xs: 0, md: 2 }} py={2} flex={{ xs: 1, md: 0.7 }} maxHeight={{ xs: "initial", md: "calc(100vh - 165px)" }}>
                        <Typography sx={{ mb: 2 }} fontWeight={500}>Candidates</Typography>
                        {candidatesLoading && <Box display="flex" justifyContent="center">
                            <CircularProgress size={40} />
                        </Box>}
                        {!candidatesLoading && <Box display="flex" flexDirection="column" gap={3}>
                            {candidates?.length === 0 && <Typography>We didn't find candidates that match <u>all</u> of the parameters. Please update the filter.</Typography>}
                            {candidates?.map(candidate => <CandidateCard key={candidate.email} candidate={candidate} />)}
                        </Box>}
                    </Box>
                </Box>}
            </Box>

        </Container>
    </Box>;
}


export default Employer;

